import { CUSTOMERS_VIEW } from 'constants/permissions'
import { ReactLazyPreload } from 'utilities/PreloadLinks'

const ClientList = ReactLazyPreload(() =>
  import('../components/ClientList').then((file) => {
    return { default: file.ClientList }
  })
)

const MembershipList = ReactLazyPreload(() =>
  import('../components/MembershipList').then((file) => {
    return { default: file.MembershipList }
  })
)

export const useRoutes = () => {
  return [
    {
      path: '/clients',
      name: 'Client profiles',
      component: ClientList,
      exact: true,
      permissions: [CUSTOMERS_VIEW],
    },
    {
      path: '/memberships',
      name: 'Memberships',
      component: MembershipList,
      exact: true,
      permissions: [CUSTOMERS_VIEW],
    },
  ]
}
